<style>
.center {
  margin: auto;
  width: 60%;
  padding: 10px;
  text-align: right;
}
</style>
<template>
  <div>
    <p
      style="padding-top:-30px"
    >Please find out your drilling activity report that need to approved.</p>
    <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-success" :small="true">
      <b-tab lazy>
        <template v-slot:title>
          Casing
          &nbsp;&nbsp;
          <b-badge v-if="rowNoCasing > 0" variant="danger">{{rowNoCasing}}</b-badge>
        </template>
        <Casing ref="cmpCasing" :field-id="fieldId" :pad-id="padId" :well-id="wellId" />
      </b-tab>
      <b-tab lazy>
        <template v-slot:title>
          Kick
          &nbsp;&nbsp;
          <b-badge v-if="rowNoKick > 0" variant="danger">{{rowNoKick}}</b-badge>
        </template>
        <Kick ref="cmpKick" :field-id="fieldId" :pad-id="padId" :well-id="wellId" />
      </b-tab>

      <b-tab lazy>
        <template v-slot:title>
          Cement
          &nbsp;&nbsp;
          <b-badge v-if="rowNoCement > 0" variant="danger">{{rowNoCement}}</b-badge>
        </template>
        <Cement ref="cmpCement" :field-id="fieldId" :pad-id="padId" :well-id="wellId" />
      </b-tab>

      <b-tab lazy>
        <template v-slot:title>
          Coring
          &nbsp;&nbsp;
          <b-badge v-if="rowNoCoring > 0" variant="danger">{{rowNoCoring}}</b-badge>
        </template>
        <Coring ref="cmpCoring" :field-id="fieldId" :pad-id="padId" :well-id="wellId" />
      </b-tab>

      <b-tab lazy>
        <template v-slot:title>
          Logging
          &nbsp;&nbsp;
          <b-badge v-if="rowNoLogging > 0" variant="danger">{{rowNoLogging}}</b-badge>
        </template>
        <Logging ref="cmpLogging" :field-id="fieldId" :pad-id="padId" :well-id="wellId" />
      </b-tab>

      <b-tab lazy>
        <template v-slot:title>
          Fishing
          &nbsp;&nbsp;
          <b-badge v-if="rowNoFishing > 0" variant="danger">{{rowNoFishing}}</b-badge>
        </template>
        <Fishing ref="cmpFishing" :field-id="fieldId" :pad-id="padId" :well-id="wellId" />
      </b-tab>

      <b-tab lazy>
        <template v-slot:title>
          Well Test
          &nbsp;&nbsp;
          <b-badge v-if="rowNoWelltest > 0" variant="danger">{{rowNoWelltest}}</b-badge>
        </template>
        <WellTest ref="cmpWellTest" :field-id="fieldId" :pad-id="padId" :well-id="wellId" />
      </b-tab>

      <b-tab lazy>
        <template v-slot:title>
          General Work
          &nbsp;&nbsp;
          <b-badge v-if="rowNoGeneralwork > 0" variant="danger">{{rowNoGeneralwork}}</b-badge>
        </template>
        <GeneralWork ref="cmpGeneralWork" :field-id="fieldId" :pad-id="padId" :well-id="wellId" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formMethods } from '@state/helpers'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import Casing from '@components/form/approval/drilling-activity/appr-casing'
import Kick from '@components/form/approval/drilling-activity/appr-kick'
import Cement from '@components/form/approval/drilling-activity/appr-cement'
import Coring from '@components/form/approval/drilling-activity/appr-coring'
import Logging from '@components/form/approval/drilling-activity/appr-logging'
import Fishing from '@components/form/approval/drilling-activity/appr-fishing'
import WellTest from '@components/form/approval/drilling-activity/appr-welltest'
import GeneralWork from '@components/form/approval/drilling-activity/appr-generalwork'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.use(VueFormGenerator)

export default {
  components: {
    Casing,
    Kick,
    Cement,
    Coring,
    Logging,
    Fishing,
    WellTest,
    GeneralWork,
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    wellId: { type: Number, default: 0 },
    padId: { type: Number, default: 0 },
    fieldId: { type: Number, default: 0 },
    countNo: Function,
  },
  data() {
    return {
      rowNoCasing: 0,
      rowNoKick: 0,
      rowNoCement: 0,
      rowNoCoring: 0,
      rowNoLogging: 0,
      rowNoFishing: 0,
      rowNoWelltest: 0,
      rowNoGeneralwork: 0,
      noRows: [0, 0, 0, 0, 0, 0, 0, 0],
      total: 0,
    }
  },

  watch: {
    wellId: function(val) {
      this.wellId = val
    },
    padId: function(val) {
      this.padId = val
    },
    fieldId: function(val) {
      this.fieldId = val
    },
  },
  created() {},

  mounted() {
    this.$watch(
      () => this.$refs.cmpCasing.$refs.tableReportList.rowNo,
      (val) => {
        this.noRows[0] = val
        this.rowNoCasing = val
        this.total = this.noRows.reduce((tot, num) => {
          return tot + num
        })
      }
    )
    this.$watch(
      () => this.$refs.cmpKick.$refs.tableReportList.rowNo,
      (val) => {
        this.noRows[1] = val
        this.rowNoKick = val
        this.total = this.noRows.reduce((tot, num) => {
          return tot + num
        })
      }
    )
    this.$watch(
      () => this.$refs.cmpCement.$refs.tableReportList.rowNo,
      (val) => {
        this.noRows[2] = val
        this.rowNoCement = val
        this.total = this.noRows.reduce((tot, num) => {
          return tot + num
        })
      }
    )
    this.$watch(
      () => this.$refs.cmpCoring.$refs.tableReportList.rowNo,
      (val) => {
        this.noRows[3] = val
        this.rowNoCoring = val
        this.total = this.noRows.reduce((tot, num) => {
          return tot + num
        })
      }
    )
    this.$watch(
      () => this.$refs.cmpLogging.$refs.tableReportList.rowNo,
      (val) => {
        this.noRows[4] = val
        this.rowNoLogging = val
        this.total = this.noRows.reduce((tot, num) => {
          return tot + num
        })
      }
    )
    this.$watch(
      () => this.$refs.cmpFishing.$refs.tableReportList.rowNo,
      (val) => {
        this.noRows[5] = val
        this.rowNoFishing = val
        this.total = this.noRows.reduce((tot, num) => {
          return tot + num
        })
      }
    )
    this.$watch(
      () => this.$refs.cmpWellTest.$refs.tableReportList.rowNo,
      (val) => {
        this.noRows[6] = val
        this.rowNoWelltest = val
        this.total = this.noRows.reduce((tot, num) => {
          return tot + num
        })
      }
    )
    this.$watch(
      () => this.$refs.cmpGeneralWork.$refs.tableReportList.rowNo,
      (val) => {
        this.noRows[7] = val
        this.rowNoGeneralwork = val
        this.total = this.noRows.reduce((tot, num) => {
          return tot + num
        })
      }
    )
  },
  methods: {
    ...formMethods,
  },
}
</script>